module.exports = __webpack_public_path__ + "static/img/cloner_chorus.7f7aa43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/cloner_chorus.png
// module id = IZYw
// module chunks = 12